import React from 'react';
import { useDescope } from '@descope/react-sdk';
import logo from '../../assets/images/center-icon.png';
import { WaitlistGateOrganism, type WaitlistGateStatus } from 'design-system/my-lib';

export interface NoOrganizationScreenProps {
  /** The person's waitlist standing from `/auth/bootstrap`; `null` when they have no waitlist entry. */
  waitlistStatus: WaitlistGateStatus | null;
  /** True when the waitlist entry is approved but the person's email is not yet verified. */
  verificationRequired?: boolean;
  email: string | null;
  checking: boolean;
  onCheckAgain: () => void;
}

/**
 * Shown to a signed-in person who belongs to no organization (see `useAppInitialization`'s
 * `no-organization` phase). There is no shell to render around, so — like the provisioning
 * screen — it stands alone and always offers *Sign out*.
 */
const NoOrganizationScreen: React.FC<NoOrganizationScreenProps> = ({
  waitlistStatus,
  verificationRequired = false,
  email,
  checking,
  onCheckAgain,
}) => {
  const { logout } = useDescope();
  return (
    <WaitlistGateOrganism
      status={waitlistStatus}
      email={email}
      verificationRequired={verificationRequired}
      checking={checking}
      onCheckAgain={onCheckAgain}
      onSignOut={() => logout()}
      logoSrc={logo}
    />
  );
};

export default NoOrganizationScreen;
